module.exports = __webpack_public_path__ + "media/media/home/_img2-f1ae84fe3b66824372397bfa3dc56cf0.png";